import React from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import TermsContainer from "../containers/terms";
import NewsletterArea from "../containers/global/newsletter";
import PageBanner from "../containers/global/page-banner";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import Layout from "../layouts/index";

const TermsConditionsPage = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO title="BunnySpire LLC – Terms and Conditions" />
                <div className="wrapper">
                    <Header />
                    <PageBanner
                        title="Terms and Conditions"
                        excerpt="Effective Date: 08-17-2023"
                        image="./images/faq/1.png"
                    />
                    <TermsContainer />
                    <NewsletterArea />
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

export default TermsConditionsPage;
